<!--Copyright (c) Laserfiche.
Licensed under the MIT License. See LICENSE in the project root for license information.-->

<div class="user-feedback-content-container lf-dialog-content">
  <lfint-toast-message id="messages" [messages]="toastMessages"></lfint-toast-message>
  <div class="lf-text-body lf-user-feedback-description">
    {{
      isFeedback
        ? (localizedStrings.FOUND_SOMETHING_LIKE_DISLIKE_LET_US_KNOW | async)
        : (localizedStrings.DO_YOU_HAVE_IDEA_NEW_FEATURE_IMPROVEMENT_LOOK_FORWARD_TO_HEARING | async)
    }}
  </div>
  <label for="feedback-suggestion-textbox" class="lf-text-label"
    >{{
      isFeedback ? (localizedStrings.TELL_US_ABOUT_EXPERIENCE | async) : (localizedStrings.TELL_US_ABOUT_IDEA | async)
    }}
    ({{ localizedStrings.REQUIRED | async }})</label
  >
  <textarea
    id="feedback-suggestion-textbox"
    rows="10"
    [attr.maxlength]="maxFeedbackLength"
    (input)="feedbackTextBoxChange($event)"
    class="lf-textarea lf-text-placeholder lf-text-body feedback-suggestion-textbox"
    [placeholder]="localizedStrings.PLEASE_DO_NOT_INCLUDE_CONFIDENTIAL_OR_PERSONAL_INFO_IN_FEEDBACK | async"
  ></textarea>
  <div class="lf-text-body character-count">
    <span>{{ feedbackLength }}</span>
    <span> / </span>
    <span>{{ maxFeedbackLength }}</span>
  </div>
  <lfint-feedback-image-upload
    id="image-upload-block"
    (feedbackImageBase64)="onFeedbackImageBase64($event)"
    (imageUploadError)="onImageUploadError($event)"
  ></lfint-feedback-image-upload>
  <div class="email-checkbox-container">
    <mat-checkbox
      color="primary"
      class="lf-user-feedback-checkbox lf-checkbox"
      [disableRipple]="true"
      ngDefaultControl
      [(ngModel)]="feedbackEmailCheckbox"
    >
      {{ localizedStrings.YOU_MAY_CONTACT_ME_ABOUT_FEEDBACK | async }}
    </mat-checkbox>
  </div>
</div>
